import { Divider } from '@mui/material'
import React from 'react'
import customDividerStyles from './customDivider.styles'

const CustomDivider: React.FC = () => {
  const styles = customDividerStyles()

  return <Divider className={styles.root} />
}

export default CustomDivider
